export const CONTACT = {
  name: "Brodheadsville Eye Care",
  phone: "610-681-6116",
  phoneHref: "tel:6106816116",
  fax: "610-681-6128",
  email: "Brodheadsvilleeyecare@yahoo.com",
  emailHref: "mailto:Brodheadsvilleeyecare@yahoo.com",
  addressLine1: "107 Kingsley Drive, Suite 102",
  addressLine2: "Brodheadsville, PA 18322",
  mapQuery: "Brodheadsville Eye Care, 107 Kingsley Dr Suite 102, Brodheadsville, PA 18322",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=Brodheadsville%20Eye%20Care%2C%20107%20Kingsley%20Dr%20Suite%20102%2C%20Brodheadsville%2C%20PA%2018322",
};

export const HOURS = [
  { day: "Monday – Thursday", time: "10:00 AM – 5:00 PM" },
  { day: "Friday", time: "10:00 AM – 4:00 PM" },
  { day: "Saturday", time: "Closed" },
  { day: "Sunday", time: "Closed" },
];

export const IMAGES = {
  heroExam: "https://images.pexels.com/photos/5621862/pexels-photo-5621862.jpeg?auto=compress&cs=tinysrgb&w=1400",
  clinicInterior: "/office/showroom.webp",
  framesShelf: "/office/frame-wall.webp",
  framesMacro: "https://images.pexels.com/photos/6011443/pexels-photo-6011443.jpeg?auto=compress&cs=tinysrgb&w=1400",
  stylishPatient: "https://images.unsplash.com/photo-1524255684952-d7185b509571?auto=format&fit=crop&w=1200&q=80",
  examPhoropter: "https://images.pexels.com/photos/5752284/pexels-photo-5752284.jpeg?auto=compress&cs=tinysrgb&w=1200",
  examCheck: "https://images.pexels.com/photos/5752289/pexels-photo-5752289.jpeg?auto=compress&cs=tinysrgb&w=1200",
  wallDisplay: "/office/tiffany-display.webp",
  sunglassesStore: "https://images.pexels.com/photos/36800178/pexels-photo-36800178.jpeg?auto=compress&cs=tinysrgb&w=1200",
  rfTreatment: "https://images.unsplash.com/photo-1689103229376-3fbfe1257242?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  {
    id: "eye-exams",
    title: "Comprehensive & Diabetic Eye Exams",
    short: "Thorough vision and ocular health evaluations, including diabetic eye exams.",
    description:
      "Our comprehensive eye exams go beyond a simple vision check. Using advanced diagnostic technology, we evaluate your visual acuity and screen for eye conditions. We also provide dedicated diabetic eye exams to monitor and protect the eye health of our patients living with diabetes.",
    image: IMAGES.examPhoropter,
    icon: "Eye",
  },
  {
    id: "eyeglasses",
    title: "Eyeglasses, Frames & Lenses",
    short: "A curated boutique of designer frames paired with premium lenses.",
    description:
      "Discover a hand-selected collection of designer frames to match every style and budget. We pair them with high-quality lenses — from anti-glare and blue-light protection to progressive and digital options — for vision that looks and feels exceptional.",
    image: IMAGES.framesShelf,
    icon: "Glasses",
  },
  {
    id: "glasses-in-an-hour",
    title: "In-House Lab — Glasses in an Hour",
    short: "Our on-site lab can have many glasses ready in about an hour (restrictions apply).",
    description:
      "Why wait weeks? Our in-house finishing lab lets us have many glasses ready in about an hour (restrictions apply). Fewer trips, faster service, and the quality assurance of glasses made right here at our practice.",
    image: IMAGES.framesMacro,
    icon: "Zap",
  },
  {
    id: "dry-eye",
    title: "TempSure Dry Eye Treatments",
    short: "Targeted TempSure relief for chronic dryness, irritation, and discomfort.",
    description:
      "Dry, gritty, or watery eyes can disrupt daily life. Our TempSure dry eye treatments use gentle radiofrequency technology to help relieve the symptoms of dry eye, restoring lasting comfort with a personalized treatment plan.",
    image: IMAGES.examCheck,
    icon: "Droplet",
  },
  {
    id: "tempsure",
    title: "TempSure Treatments",
    short: "Non-invasive radiofrequency to reduce fine lines and rebuild collagen.",
    description:
      "TempSure uses gentle radiofrequency energy to help reduce fine lines and rebuild collagen. It's a non-invasive treatment with natural-looking results and no downtime — a refreshing way to care for your skin.",
    image: IMAGES.rfTreatment,
    icon: "Sparkles",
  },
];

export const BRANDS = [
  "Ray-Ban", "Ray-Ban Meta", "Tiffany & Co.", "Michael Kors", "Coach", "Nike",
  "Harley-Davidson", "Ralph Lauren", "Flexon", "Eddie Bauer",
];

export const LENSES = [
  { title: "Crizal", desc: "Premium anti-reflective coatings that protect against glare, scratches, smudges, water, dust, and UV — for clearer, more durable lenses." },
  { title: "Transitions", desc: "Photochromic lenses that automatically darken in sunlight and turn clear indoors, adapting to changing light all day." },
  { title: "Essilor", desc: "A world-leading lens manufacturer offering advanced lens technology engineered for sharp, comfortable, high-definition vision." },
  { title: "Eyezen", desc: "Single-vision lenses designed to reduce digital eye strain and help filter harmful blue light from screens." },
  { title: "Varilux", desc: "Progressive lenses delivering seamless, sharp vision at every distance — near, intermediate, and far — with no visible lines." },
  { title: "Varilux Immersia", desc: "Varilux's most advanced progressive lens, offering the widest fields of view and the smoothest edge-to-edge transitions." },
];

export const DOCTOR_BIO = {
  name: "Dr. Izabella Busher, OD",
  role: "Optometrist",
  photo: "/team/dr-busher.jpg",
  paragraphs: [
    "Dr. Izabella Busher earned a Bachelor of Science degree in Health Sciences from Gettysburg College before receiving her Doctor of Optometry degree from the Pennsylvania College of Optometry, where she graduated magna cum laude.",
    "With more than three years of experience providing comprehensive optometric care, Dr. Busher is dedicated to helping patients achieve and maintain healthy vision. She takes a patient-centered approach to eye care, focusing on each patient's individual needs and ensuring they feel comfortable and informed throughout their care.",
    "Dr. Busher is passionate about providing high-quality eye care and building lasting relationships with her patients and their families.",
  ],
};

export const STORY = {
  eyebrow: "Our Story",
  title: "Where My Career Began — and Where I Came Home",
  part1: [
    "More than 20 years ago, I walked through the doors of Brodheadsville Eye Care at the very beginning of my career in optical. I had no idea then that one day I would return to those same doors as the owner.",
    "I began my career here as an apprentice optician, learning the profession under longtime owner and optician Zane Burke. It was here that I learned much more than how to fit a pair of glasses or work with lenses. I learned the importance of knowing your patients, listening to them, and treating every person who walks through the door like they truly matter.",
    "Over the next 23 years, I built my career in the optical field, including 18 years in optical management. Those years gave me invaluable experience, but I never forgot where it all started—or the kind of personal, small-town care that made Brodheadsville Eye Care special.",
    "In 2025, my career came full circle when I was given the opportunity to take over the practice where my journey began.",
    "For me, becoming the owner of Brodheadsville Eye Care wasn't simply about buying a business. It was about continuing the legacy of a practice that has cared for families in our community for more than three decades, while also creating something for its next chapter.",
  ],
  subheading: "A New Chapter, With the Same Hometown Heart",
  part2: [
    "Today, Brodheadsville Eye Care remains proudly independent and family owned.",
    "I wanted to create the kind of optical practice I believe patients deserve—professional and knowledgeable, but also comfortable, friendly and down-to-earth. A place where you aren't treated like a number and where decisions can be made based on what's best for the person sitting in front of us, rather than the rules of a large corporation.",
    "We've continued to grow while holding onto that philosophy. Our practice offers comprehensive eye care, eyewear and contact lenses, an on-site optical lab, dry-eye treatments and additional specialty services. We continue to expand our doctor coverage and services so that our patients can receive more of the care they need right here in their own community.",
    "And while a lot has changed since I first started here all those years ago, one thing hasn't:",
  ],
  highlight: "The patient still comes first.",
  part3: [
    "There is something incredibly special about standing in the same practice where I once began as an apprentice and now having the opportunity to lead it into its next generation.",
    "Brodheadsville Eye Care helped give me my start.",
    "Now it's my privilege to give back to the community that helped me build my career—and to make sure this little hometown practice continues caring for local families for many years to come.",
  ],
  signature: {
    name: "Tanna Battaglino",
    role: "Owner & Optician",
    practice: "Brodheadsville Eye Care",
    photo: "/team/tanna.jpg",
  },
};

export const TEAM = [
  { name: "Dr. Izabella Busher, OD", role: "Optometrist", photo: "/team/dr-busher.jpg" },
  { name: "Tanna Battaglino", role: "Owner, Optician, Lab & Radiofrequency Technician", photo: "/team/tanna.jpg" },
  { name: "Britani Betts", role: "Patient Coordinator", photo: "/team/coordinator1.jpg" },
  { name: "Frank Battaglino", role: "Patient Coordinator", photo: "/team/frank.jpg" },
];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/?q=place_id:ChIJC-wGC1hZxIkRJocbRj8WeJ0";

export const ANNOUNCEMENT = {
  enabled: true,
  text: "Don't let your vision insurance benefits expire — use them before year-end!",
};

export const REVIEWS = [
  {
    source: "Google Review",
    text: "I have never had such a wonderful experience at the eye doctor. These people are amazing, professional and incredibly kind and I loved talking to them.",
  },
  {
    source: "Google Review",
    text: "I have been going there for about 20 years and I have never had a bad experience… If you need any adjustments made it's done quickly and correctly. I highly recommend them for all your needs.",
  },
  {
    source: "Google Review",
    text: "Very honest people when it comes to your eye exams… A great place that provides great hospitality to their customers.",
  },
];

